
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -1 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#D2D5D9"}}),_c('path',{staticClass:"black-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.854 9.6h10.29c2.019 0 3.655 1.682 3.655 3.756v5.287c0 2.075-1.636 3.757-3.655 3.757h-10.29c-2.018 0-3.655-1.682-3.655-3.757v-5.287c0-2.074 1.637-3.756 3.655-3.756zm3.004 9.017l4.813-2.36a.201.201 0 00.004-.356l-4.812-2.506c-.129-.067-.281.029-.281.177v4.866c0 .146.148.242.276.179z","fill":"#fff"}})])
          )
        }
      }
    